export default "__VITE_PUBLIC_ASSET__9afe6965__"